export const AUTODESK_TRANSLATION_LIMIT_MESSAGE =
  'Translation capacity reached. Please add more translation capacity to your Autodesk account to continue.';

export function translationStartErrorMessage(payload, fallback) {
  const error = String(payload?.error || '');
  const message = String(payload?.message || '');
  const combined = `${error} ${message} ${fallback || ''}`.toLowerCase();
  if (
    error === 'FORGE_QUOTA_EXCEEDED' ||
    combined.includes('productaccessrequirescapacity') ||
    combined.includes('token exchange denied')
  ) {
    return AUTODESK_TRANSLATION_LIMIT_MESSAGE;
  }
  return message || error || fallback || 'Failed to start translation';
}
